export default "__VITE_ASSET__89280cf3__"